import { createVNode, createComponentVNode, createTextVNode } from "inferno";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { Component } from 'inferno';
import InputSelect from 'dmn-js-shared/lib/components/InputSelect';
var HIT_POLICIES = ['UNIQUE', 'FIRST', 'PRIORITY', 'ANY', 'COLLECT', 'RULE ORDER', 'OUTPUT ORDER'];
var DEFAULT_AGGREGATION = 'NO LIST AGGREGATION';
var LIST_FUNCTIONS = [DEFAULT_AGGREGATION, 'SUM', 'MIN', 'MAX', 'COUNT'];

var HitPolicyCellContextMenu =
/*#__PURE__*/
function (_Component) {
  _inherits(HitPolicyCellContextMenu, _Component);

  function HitPolicyCellContextMenu(props, context) {
    var _this;

    _classCallCheck(this, HitPolicyCellContextMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HitPolicyCellContextMenu).call(this, props, context));
    _this.onHitPolicyChange = _this.onHitPolicyChange.bind(_assertThisInitialized(_this));
    _this.onAggregationChange = _this.onAggregationChange.bind(_assertThisInitialized(_this));
    _this.onElementsChanged = _this.onElementsChanged.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(HitPolicyCellContextMenu, [{
    key: "onHitPolicyChange",
    value: function onHitPolicyChange(hitPolicy) {
      var root = this._sheet.getRoot(),
          businessObject = root.businessObject;

      var aggregation = hitPolicy === 'COLLECT' ? businessObject.aggregation : undefined;

      this._modeling.editHitPolicy(hitPolicy, aggregation);
    }
  }, {
    key: "onAggregationChange",
    value: function onAggregationChange(aggregation) {
      this._modeling.editHitPolicy('COLLECT', aggregation);
    }
  }, {
    key: "onElementsChanged",
    value: function onElementsChanged() {
      this.forceUpdate();
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var injector = this.context.injector;
      var changeSupport = this._changeSupport = this.context.changeSupport;
      this._sheet = injector.get('sheet');
      this._modeling = injector.get('modeling');

      var root = this._sheet.getRoot(),
          businessObject = root.businessObject,
          hitPolicy = businessObject.hitPolicy,
          aggregation = businessObject.aggregation;

      changeSupport.onElementsChanged(root.id, this.onElementsChanged);
      this.state = {
        hitPolicy: hitPolicy,
        aggregation: aggregation
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var root = this._sheet.getRoot();

      this._changeSupport.offElementsChanged(root.id, this.onElementsChanged);
    }
  }, {
    key: "render",
    value: function render() {
      var root = this._sheet.getRoot(),
          businessObject = root.businessObject,
          hitPolicy = businessObject.hitPolicy,
          aggregation = businessObject.aggregation;

      var hitPolicyOptions = HIT_POLICIES.map(function (h) {
        return {
          label: h,
          value: h
        };
      });
      var aggregationOptions = LIST_FUNCTIONS.map(function (l) {
        return {
          label: l,
          value: l === DEFAULT_AGGREGATION ? undefined : l
        };
      });
      return createVNode(1, "div", "context-menu-container hit-policy-edit", [createVNode(1, "p", "hit-policy-edit-policy", [createVNode(1, "label", "dms-label", createTextVNode("Hit Policy:"), 2), createComponentVNode(2, InputSelect, {
        "noInput": true,
        "className": "hit-policy-edit-policy-select",
        "onChange": this.onHitPolicyChange,
        "options": hitPolicyOptions,
        "value": hitPolicy
      })], 4), hitPolicy === 'COLLECT' && createVNode(1, "p", "hit-policy-edit-operator", [createVNode(1, "label", "dms-label", createTextVNode("Aggregation:"), 2), createComponentVNode(2, InputSelect, {
        "noInput": true,
        "className": "hit-policy-edit-operator-select",
        "onChange": this.onAggregationChange,
        "options": aggregationOptions,
        "value": aggregation
      })], 4)], 0);
    }
  }]);

  return HitPolicyCellContextMenu;
}(Component);

export { HitPolicyCellContextMenu as default };
//# sourceMappingURL=HitPolicyCellContextMenu.js.map